<template>
<div id="empresas">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="domain" title="Registro Fiscal" class="elevation-1 px-5 py-3">

          <v-card-text>

            <v-card>
              <v-card-title>
                <span class="headline">{{model.nombre}}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-form ref="formempresa">
                    <v-card-text>
                      <v-form ref="form">
                        <v-card>

                          <v-card-text>

                            <v-row>
                              <v-col sm="6" md="6">
                                <v-text-field v-model="model.razon_social" label="Razón Social" :rules="[rules.required]"></v-text-field>
                              </v-col>
                              <v-col sm="6" md="6">
                                <v-text-field @input="model.rfc = model.rfc.toUpperCase()" v-model="model.rfc" label="RFC" :rules="[rules.required]"></v-text-field>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col sm="12" md="12">
                                <v-autocomplete v-model="model.regimen" label="Regimen Fiscal" :rules="[this.$rules.required]" :items="regimenes" :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col sm="4" md="4" lg="4">
                                <v-text-field v-model="model.domicilio.codigo_postal" label="Codigo Postal" @blur="searchCP" :rules="[validaEntero]" maxlength="5"></v-text-field>
                              </v-col>
                              <v-col sm="4" md="4" lg="4">
                                <v-autocomplete v-model="model.domicilio.pais" label="País" :rules="[this.$rules.required]" :loading="loadPais" @change="Estados(model.domicilio.pais)" :items="sat_paises" :hide-no-data="true" item-text="nombre"
                                  item-value="clave"></v-autocomplete>
                              </v-col>
                              <v-col sm="4" md="4" lg="4">
                                <v-autocomplete v-model="model.domicilio.estado" label="Estado" :rules="[this.$rules.required]" :loading="loadEstado" @change="Municipios(model.domicilio.estado); cargarLocalidades(model.domicilio.estado)"
                                  :items="sat_estados" :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col sm="4" md="4" lg="4">
                                <v-autocomplete v-model="model.domicilio.municipio" label="Municipio" :rules="[this.$rules.required]" @change="sat_colonias=[]; searchColoniasCombo()" :loading="loadMunicipio" :items="sat_municipios"
                                  :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                              </v-col>
                              <v-col sm="4" md="4" lg="4">
                                <v-autocomplete v-model="model.domicilio.localidad" label="Localidad" :loading="loadLocalidad" @change="sat_colonias=[]; searchColoniasCombo()" :items="sat_localidades" :hide-no-data="true" item-text="nombre"
                                  item-value="clave"></v-autocomplete>
                              </v-col>
                              <v-col sm="4" md="4" lg="4">
                                <v-autocomplete v-model="model.domicilio.colonia" label="Colonia" :loading="loadColonia" :items="sat_colonias" :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col sm="6" md="6" lg="6">
                                <v-text-field v-model="model.domicilio.calle" label="Calle" :rules="[this.$rules.required]"></v-text-field>
                              </v-col>
                              <v-col sm="3" md="3" lg="3">
                                <v-text-field v-model="model.domicilio.numero_ext" label="No. Exterior" :rules="[this.$rules.required]"></v-text-field>
                              </v-col>
                              <v-col sm="3" md="3" lg="3">
                                <v-text-field v-model="model.domicilio.numero_int" label="No. Interior"></v-text-field>
                              </v-col>
                            </v-row>

                          </v-card-text>
                        </v-card>
                        <v-card width="100%">
                          <v-subheader>Certificado:</v-subheader>
                          <v-card-text>
                            <v-row>
                              <v-col cols="12" sm="6" md="6">
                                <v-text-field label="Seleccione el archivo .cer" @click='pickFile' v-model='name_file' :readonly="true" prepend-icon='attach_file' :rules="tieneCertificado?[rules.required]:[]"></v-text-field>
                                <input type="file" style="display: none" ref="file_input" accept=".cer" @change="onFilePicked">
                                <!-- <v-btn small v-if="(model.certificado.cer!=null && model.certificado.cer!='')" @click="downloadFile(model.certificado.cer, 'cer')">Descargar .cer</v-btn> -->
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-text-field label="Seleccione el archivo .key" @click='pickFileKey' v-model='name_file_key' :readonly="true" prepend-icon='attach_file' :rules="tieneCertificado?[rules.required]:[]"></v-text-field>
                                <input type="file" style="display: none" ref="file_input_key" accept=".key" @change="onFilePickedKey">
                                <!-- <v-btn small v-if="(model.certificado.key!=null && model.certificado.key!='')" @click="downloadFile(model.certificado.key, 'key')">Descargar .key</v-btn>                               -->
                              </v-col>
                              <v-col cols="12" sm="12" md="12">
                                <v-text-field v-model="model.certificado.pass" type="password" label="Pass" :rules="tieneCertificado?[rules.required]:[]"></v-text-field>
                              </v-col>

                            </v-row>
                            <v-row>
                              <v-col sm="6" md="6">

                                <strong>Agregar Logo:</strong>
                                <p />
                                Importante: Logo será redimensionado a una resolucion máxima de 400 de ancho x 200 de alto pixeles
                                <p />
                                <p />
                                <v-row>
                                  <v-col sm="6" md="6">
                                    <image-uploader :debug="0" :maxWidth="400" :maxHeight="200" :quality="1" outputFormat="string" :preview="false" :className="['fileinput', { 'fileinput--loaded' : hasImage }]" accept="image/png"
                                      doNotResize="['gif', 'svg', 'png']" @input="setImage" @onUpload="startImageResize" @onComplete="endImageResize">
                                    </image-uploader>
                                  </v-col>
                                  <v-col sm="6" md="6">

                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col sm="8" md="8">
                                    
                                    <img v-if="(model.logo!=undefined && model.logo!='')" style="" :src="'data:image/png;base64,'+model.logo" width="auto"  >
                                  </v-col>
                                  <v-col sm="2" md="2">

                                    <v-btn color="info" small v-if="(model.logo!=null && model.logo!='')" @click="downloadFile(model.logo, 'png')" title="Descargar" v-tippy>
                                      <v-icon small>mdi-download</v-icon>
                                    </v-btn>
                                    <p />
                                    <v-btn color="red" dark small v-if="(model.logo!=null && model.logo!='')" @click="model.logo=''; reset();" title="Eliminar" v-tippy>
                                      <v-icon small>mdi-trash-can</v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>



                              </v-col>
                              <v-col sm="6" md="6">
                                <h6>Folio y Serie sin Complementos</h6>
                                <v-row>
                                  <v-col sm="6" md="6">
                                    <v-text-field v-model="model.serie" label="Serie"></v-text-field>
                                  </v-col>
                                  <v-col sm="6" md="6">
                                    <v-text-field v-model="model.folio" label="Folio"></v-text-field>
                                  </v-col>
                                </v-row>
                                <h6>Folio y Serie Complemento Carta Porte</h6>
                                <v-row>
                                  <v-col sm="6" md="6">
                                    <v-text-field v-model="model.serie_2" label="Serie"></v-text-field>
                                  </v-col>
                                  <v-col sm="6" md="6">
                                    <v-text-field v-model="model.folio_2" label="Folio"></v-text-field>
                                  </v-col>
                                </v-row>
                                <h6>Folio y Serie Complemento Pagos</h6>
                                <v-row>
                                  <v-col sm="6" md="6">
                                    <v-text-field v-model="model.serie_3" label="Serie"></v-text-field>
                                  </v-col>
                                  <v-col sm="6" md="6">
                                    <v-text-field v-model="model.folio_3" label="Folio"></v-text-field>
                                  </v-col>
                                </v-row>
                                <h6>Folio y Serie Notas de Crédito</h6>
                                <v-row>
                                  <v-col sm="6" md="6">
                                    <v-text-field v-model="model.serie_4" label="Serie"></v-text-field>
                                  </v-col>
                                  <v-col sm="6" md="6">
                                    <v-text-field v-model="model.folio_4" label="Folio"></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col sm="12">
                                <h5><b>Catalogo de Series</b></h5>
                              </v-col>
                              <v-col sm="2" md="2" lg="2">
                                  <v-text-field v-model="serie_c"  class="text-center"  label="Serie" @input="serie_c = serie_c.toUpperCase()"></v-text-field>
                              </v-col>
                              <v-col sm="2" md="2" lg="2">
                                  <v-text-field  v-model="folio_c" label="Folio"></v-text-field>
                              </v-col>
                              <v-col sm="1" md="1" lg="1">
                                 <v-btn color="default" large @click="agregar_serie_folio()" title="Agregar" v-tippy>
                                     <v-icon>mdi-plus-box</v-icon>
                                 </v-btn>
                             </v-col>
                             <v-col sm="12">
                               <v-client-table ref="vuetable" :data="model.catalogo_series" :columns="['serie', 'folio', 'acciones']" :options="{}" class="elevation-3 pa-5">
                                   <template slot="acciones" slot-scope="props">
                                       <v-btn color="error" fab x-small title="Eliminar Registro" @click="eliminar_serie_folio(props.row.serie)">
                                           <v-icon>mdi-trash-can</v-icon>
                                       </v-btn>
                                   </template>
                               </v-client-table>
                             </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-form>

                    </v-card-text>

                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="success" small @click="guardar">
                  <v-icon small>mdi-check-circle-outline</v-icon> Actualizar
                </v-btn>
              </v-card-actions>
            </v-card>


          </v-card-text>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import moment from "moment";
import ImageUploader from 'vue-image-upload-resize';
export default {
  name: "DashboardDataTables",
  components: {
    ImageUploader
  },
  data: () => ({
    URL: "",
    URL_SAT: "",
    serie_c: null,
    folio_c: null,
    sat_paises: [],
    sat_estados: [],
    sat_localidades: [],
    sat_municipios: [],
    sat_colonias: [],
    regimenes: [],
    loadPais: false,
    name_file: "",
    hasImage: false,
    loadLocalidad: false,
    loadEstado: false,
    loadMunicipio: false,
    loadColonia: false,
    id_empresa: "",
    modal: false,
    menu1: false,
    file_cer: [],
    file_key: [],
    name_file: "",
    name_file_key: "",
    items: [],
    tabla: "empresas",
    modal: false,
    usuario: "",
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home",
      },
      {
        text: "Empresas",
        disabled: true,
        href: "",
      },
    ],
    estatus: [{
      "estatus": "Activo"
    }, {
      "estatus": "Inactivo"
    }],
    model: {
      uuid: "",
      nombre: "",
      serie: "",
      folio: "",
      serie_2: "",
      serie_3: "",
      serie_4: "",
      folio_2: "",
      folio_3: "",
      folio_4: "",
      domicilio: {
        calle: "",
        numero_ext: "",
        numero_int: "",
        colonia: "",
        localidad: "",
        ciudad: "",
        municipio: "",
        estado: "",
        codigo_postal: "",
        referencias: ""
      },
      certificado: "",
      contacto: {
        nombre: "",
        telefono: "",
        email: ""
      },
      telefono: [],
      estatus: "",
      email: "",
      creado: {
        usuario: "",
        fecha: ""
      },
      actualizado: [],
      impuestos: [],
      tags: [],
      tipos_precio: [],
      pagos: [],
      licencias: [],
      registro_fiscal: [],
      catalogo_series: [],
      parametros: {
        clientes: true,
        proveedores: true,
        productos: true,
        tags: true,
        tipos_precio: true,
        impuestos: true
      },
    },

    updateModel: false,
    rules: {},
    headers: [{
        text: "Nombre",
        value: "nombre",
      },
      {
        text: "RFC",
        value: "rfc",
      },
      {
        text: "Estatus",
        value: "estatus",
      },
      {
        sortable: false,
        text: "Operaciones",
        value: "actions",
      },
    ],
    columns: ["nombre", "rfc", "estatus", "contacto.nombre", "actions"],
    options: {
      filterable: ["nombre", "rfc", "estatus", "contacto.nombre"],
      sortable: ["nombre", "rfc", "estatus", "contacto.nombre"],

      headings: {
        nombre: "Nombre",
        rfc: "RFC",
        estatus: "Estatus",
        "contacto.nombre": "Contacto",
        actions: "Operaciones"
      }
    },
    items: [],
    search: undefined,
  }),
  computed: {
    tituloModal() {
      return this.updateModel === "Datos Fiscales";
    },
  },
  methods: {
    validaEntero: function(value) {
      const pattern = /^[\d]*$/;
      if (value != null && !pattern.test(value)) {
        return "Solo se acepta números";
      } else
        return true;
    },
    cargar: function() {
      let self = this;
      self.items = [];
      this.id_empresa = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa")));
      this.$root.$dialogLoader.show("Espere un momento por favor..");

      var params = {
        filtros: {
          uuid: this.id_empresa,
        }
      };
      this.$axios.post(this.URL + "list_empresas/", params)
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.editar(res.data[0]);
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener los registros.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.$root.$dialogLoader.hide();
        });
    },

    editar: function(item) {
      //console.log("ITEM", item);
      this.model = item;

      let self = this;

      if (self.model.domicilio != undefined) {
        if (self.model.domicilio.codigo_postal != null && self.model.domicilio.codigo_postal != "")
          self.searchColonias(self.model.domicilio.codigo_postal);
        else
          self.searchColoniasCombo();
        if (self.model.domicilio.pais != null && self.model.domicilio.pais != "")
          self.cargarEstados(this.model.domicilio.pais);
        if (self.model.domicilio.estado != self && self.model.domicilio.estado != "") {
          self.cargarMunicipios(self.model.domicilio.estado);
          self.cargarLocalidades(self.model.domicilio.estado);
        }
      } else {
        self.model.domicilio = {
          calle: "",
          numero_ext: "",
          numero_int: "",
          colonia: "",
          localidad: "",
          ciudad: "",
          municipio: "",
          estado: "",
          codigo_postal: "",
          referencias: ""
        };
      }
      if (self.model.certificado == undefined) {
        self.model.certificado = {
          cer: "",
          key: "",
          pass: "",
        };
      }
      if (self.model.logo == undefined) {
        self.model.logo = "";
      }

      this.reset();
      if (this.tieneCertificado) {
        this.name_file = this.model.rfc + ".cer";
        this.name_file_key = this.model.rfc + ".key";
      }
      this.modal = true;
      this.updateModel = true;
    },
    editarRegistro: function() {
      var self = this;
      if (this.$refs.form.validate()) {
        var actualizado = {
          usuario: this.usuario,
          fecha: moment().format('YYYY-MM-DD HH:mm:ss')
        }
        this.model.certificado.actualizado.push(actualizado);
        this.guardar();
      }
    },

    searchCP: async function() {
      var val = this.model.domicilio.codigo_postal;
      if (val != null && val.toString().trim() != "" && val.toString().trim().length >= 4) {
        var cp = val.toString().trim();
        if (cp.length == 4) {
          cp = "0" + cp;
        } else if (cp.length > 5) {
          return false;
        }

        //console.log("CP: ",cp);

        //TODO: Buscar codigo postal, traer estado, municipio, localidad para llenar esos combos
        var params = {
          filtros: {
            clave: cp,
          },
        };

        var self = this;
        this.$axios.post(this.URL_SAT + "list_codigos_postales/", params)
          .then(res => {
            if (typeof res.data !== "undefined") {
              var codigo = res.data[0];

              //Buscar estado
              self.sat_estados = [];
              self.searchEstado(codigo);

              //Buscar municipio
              self.sat_municipios = [];
              self.searchMunicipio(codigo);

              //Buscar localidad
              self.sat_localidades = [];
              self.searchLocalidad(codigo);
            }
          })
          .catch(err => {
            this.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al buscar Código Postal.",
              footer: "",
            });
            console.log(err);
          });

        //Buscar Colonias
        self.sat_colonias = [];
        this.searchColonias(cp);
      }
    },
    searchColonias: function(cp) {
      var self = this;
      self.loadColonia = true;

      var params = {
        filtros: {
          codigo_postal: cp,
        }
      };

      this.$axios.post(this.URL_SAT + "list_colonias/", params)
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.sat_colonias = res.data.sort(function(a, b) {
              if (a.nombre > b.nombre)
                return 1;
              if (a.nombre < b.nombre)
                return -1;
              return 0;
            });
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al buscar las colonias.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.loadColonia = false;
        });

    },
    searchColoniasCombo: function() {
      var self = this;
      if ((self.model.domicilio.codigo_postal == null || self.model.domicilio.codigo_postal == "") &&
        self.model.domicilio.estado != null && self.model.domicilio.municipio != null &&
        self.model.domicilio.localidad != null) {

        self.loadColonia = true;

        let params = {
          filtros: {
            clave_estado: self.model.domicilio.estado,
            clave_municipio: self.model.domicilio.municipio,
            clave_localidad: self.model.domicilio.localidad
          }
        }
        this.$axios.post(this.URL_SAT + "list_codigos_postales/", params)
          .then(res => {
            if (typeof res.data !== "undefined") {
              var codigos = res.data;
              codigos.forEach(element => {
                self.searchColonias(element["clave"]);
              });
            } else
              self.loadColonia = false;
          })
          .catch(err => {
            this.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al buscar codigo postal para colonias.",
              footer: "",
            });
            console.log(err);
          });
      }
    },
    getColonia: function(clave, cp) {
      var self = this;
      self.loadColonia = true;
      var params = {
        filtros: {
          clave: clave,
          codigo_postal: cp,
        },
      };

      this.$axios.post(this.URL_SAT + "list_colonias/", params)
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.sat_colonias = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener la colonia.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.loadColonia = false;
        });
    },

    searchEstado: function(codigo) {
      var self = this;
      self.loadEstado = true;

      var params = {
        filtros: {
          clave: codigo["clave_estado"]
        }
      };

      this.$axios.post(this.URL_SAT + "list_estados/", params)
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.model.domicilio.pais = res.data[0]["clave_pais"];
            self.cargarEstados(self.model.domicilio.pais);
            self.model.domicilio.estado = res.data[0]["clave"];
            self.cargarMunicipios(self.model.domicilio.estado);
            self.cargarLocalidades(self.model.domicilio.estado);
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al buscar el estado.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.loadEstado = false;
        });

    },
    searchMunicipio: function(codigo) {
      var self = this;
      self.loadMunicipio = true;
      var params = {
        filtros: {
          clave: codigo["clave_municipio"],
          estado: codigo["clave_estado"]
        }
      };

      this.$axios.post(this.URL_SAT + "list_municipios/", params)
        .then(res => {
          if (typeof res.data !== "undefined" && res.data.length > 0) {
            self.model.domicilio.municipio = res.data[0]["clave"];
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al buscar el municipio.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.loadMunicipio = false;
        });

    },
    searchLocalidad: function(codigo) {
      var self = this;
      if (codigo["clave_localidad"] != null && codigo["clave_localidad"] != "") {
        self.loadLocalidad = true;
        var params = {
          filtros: {
            clave: codigo["clave_localidad"],
            clave_estado: codigo["clave_estado"]
          }
        };
        this.$axios.post(this.URL_SAT + "list_localidades/", params)
          .then(res => {
            if (typeof res.data !== "undefined") {
              self.model.domicilio.localidad = res.data[0]["clave"];
            }
          })
          .catch(err => {
            this.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al buscar la localidad.",
              footer: "",
            });
            console.log(err);
          }).then(() => {
            self.loadLocalidad = false;
          });
      }
    },
    cargarPaises: function() {
      var self = this;
      self.loadPais = true;
      self.sat_paises = [];
      this.$axios.post(this.URL_SAT + "list_paises/")
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.sat_paises = res.data.sort(function(a, b) {
              if (a.nombre > b.nombre)
                return 1;
              if (a.nombre < b.nombre)
                return -1;
              return 0;
            });
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener los países.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.loadPais = false;
        });
    },
    cargarEstados: function(clave_pais) {
      //console.log("CARGAR ESTADOS");
      var params = {
        filtros: {
          clave_pais: clave_pais
        }
      };
      var self = this;
      self.loadEstado = true;
      self.sat_estados = [];
      this.$axios.post(this.URL_SAT + "list_estados/", params)
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.sat_estados = res.data.sort(function(a, b) {
              if (a.nombre > b.nombre)
                return 1;
              if (a.nombre < b.nombre)
                return -1;
              return 0;
            });
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener los estados.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.loadEstado = false;
        });

    },
    cargarMunicipios: function(clave_estado) {
      var params = {
        filtros: {
          estado: clave_estado
        }
      };
      var self = this;
      self.loadMunicipio = true;
      self.sat_municipios = [];
      this.$axios.post(this.URL_SAT + "list_municipios/", params)
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.sat_municipios = res.data.sort(function(a, b) {
              if (a.nombre > b.nombre)
                return 1;
              if (a.nombre < b.nombre)
                return -1;
              return 0;
            });
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener los municipios.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.loadMunicipio = false;
        });

    },
    cargarLocalidades: function(clave_estado) {
      var params = {
        filtros: {
          clave_estado: clave_estado
        }
      };
      var self = this;
      self.loadLocalidad = true;
      self.sat_localidades = [];
      this.$axios.post(this.URL_SAT + "list_localidades/", params)
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.sat_localidades = res.data.sort(function(a, b) {
              if (a.nombre > b.nombre)
                return 1;
              if (a.nombre < b.nombre)
                return -1;
              return 0;
            });
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener las localidades.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.loadLocalidad = false;
        });

    },
    cargarRegimenes: function(clave_estado) {
      var params = {
        TableName: "regimen_fiscales",
      };
      var self = this;

      self.regimenes = [];
      this.$axios.post(this.URL_SAT + "list_regimen_fiscales/")
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.regimenes = res.data.sort(function(a, b) {
              if (a.nombre > b.nombre)
                return 1;
              if (a.nombre < b.nombre)
                return -1;
              return 0;
            });
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener los regimenes.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.loadLocalidad = false;
        });
    },

    validaUnico: function(value) {
      var self = this;
      if (value != null && value.toString().trim() != "") {
        var filter = this.model.filter(function(item) {
          return item.rfc.toString().toLowerCase().trim() == value.toString().toLowerCase().trim() && self.getIndex(item) != self.indexSeleccionado;
        });
        if (filter.length > 0)
          return "El RFC ya existe";
      }
      return true
    },
    pickFile() {
      this.$refs.file_input.click();
    },
    pickFileKey() {
      this.$refs.file_input_key.click();
    },
    onFilePicked(e) {
      try {
        const files = e.target.files;
        if (files[0] !== undefined) {
          this.name_file = files[0].name;
          //this.size_file = files[0].size;
          if (this.name_file.lastIndexOf('.') <= 0) {
            return
          }
          //var thisObj = this;
          const fr = new FileReader()
          fr.readAsDataURL(files[0])

          fr.addEventListener('load', () => {
            this.model.certificado.cer = fr.result; // this is an image file that can be sent to server...
            var n = this.model.certificado.cer.search("base64,");
            //Para dejar solo el archivo en base 64 y quitar laparte de "text/plain; base64,"
            if (n >= 0) {
              this.model.certificado.cer = this.model.certificado.cer.substring(n + 7);
            }
          });
        }
      } catch (error) {
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
          footer: ""
        });
        this.reset();
      }
    },
    onFilePickedKey(e) {
      try {
        const files = e.target.files;
        if (files[0] !== undefined) {
          this.name_file_key = files[0].name;
          //this.size_file = files[0].size;
          if (this.name_file_key.lastIndexOf('.') <= 0) {
            return
          }
          //var thisObj = this;
          const fr = new FileReader()
          fr.readAsDataURL(files[0])

          fr.addEventListener('load', () => {
            this.model.certificado.key = fr.result; // this is an image file that can be sent to server...
            var n = this.model.certificado.key.search("base64,");
            //Para dejar solo el archivo en base 64 y quitar laparte de "text/plain; base64,"
            if (n >= 0) {
              this.model.certificado.key = this.model.certificado.key.substring(n + 7);
            }
          });
        }
      } catch (error) {
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
          footer: ""
        });
        this.reset();
      }
    },
    reset: function() {
      const input = this.$refs.file_input;
      if (input != undefined) {
        input.type = 'text';
        input.type = 'file';
      }
      this.name_file = '';
      const input2 = this.$refs.file_input_key;
      if (input2 != undefined) {
        input2.type = 'text';
        input2.type = 'file';
      }
      this.name_file_key = '';
    },
    base64ToArrayBuffer: function(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    downloadFile: function(file, tipo) {
      this.$root.$dialogLoader.show('Espere un momento por favor..');

      try {
        var typeFile = "application/octet-stream";
        var nombre = this.model.rfc;
        if (tipo == "cer") {
          typeFile = "application/x-x509-ca-cert";
          nombre += ".cer";
        } else if (tipo == "key") {
          nombre += ".key";
        } else {
          nombre += ".png";
        }
        let blob = new Blob([this.base64ToArrayBuffer(file)], {
            type: typeFile
          }),
          url = window.URL.createObjectURL(blob);

        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";

        a.href = url;
        a.download = nombre;
        a.click();

        a.parentNode.removeChild(a);
        this.$root.$dialogLoader.hide();
      } catch (error) {
        //console.log(error);
        this.$root.$dialogLoader.hide();
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: "No se encontró el archivo a descargar",
          footer: '',
        });
      }

    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },

    tieneCertificado() {
      return (this.model.certificado.cer != null && this.model.certificado.cer != '') || (this.model.certificado.key != null && this.model.certificado.key != '')
    },
    setImage: function(output) {
      this.hasImage = true;
      this.model.logo = output;
      var n = this.model.logo.search("base64,");
      //Para dejar solo el archivo en base 64 y quitar laparte de "text/plain; base64,"
      if (n >= 0) {
        this.model.logo = this.model.logo.substring(n + 7);
      }
    },
    startImageResize: function(output) {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
    },
    endImageResize: function(output) {
      this.$root.$dialogLoader.hide();
    },
    agregar_serie_folio: function() {
      if(this.serie_c == null || this.serie_c == "" || this.serie_c == undefined) {
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: "Debes agregar una serie válida",
          footer: '',
        });

        return;
      } else {
        var fil = this.model.catalogo_series.filter(x => x.serie.toUpperCase() == this.serie_c.toUpperCase());
        if(fil.length > 0) {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ya existe la serie ingresada",
            footer: '',
          });

          return;
        } else {
          if(this.folio_c > 0) {
            var nueva_serie = {"serie": this.serie_c.toUpperCase(), "folio": this.folio_c};
          } else {
            var nueva_serie = {"serie": this.serie_c.toUpperCase(), "folio": "1"};
          }

          this.model.catalogo_series.push(nueva_serie);
          this.serie_c = null;
          this.folio_c = null;

        }
      }
    },
    eliminar_serie_folio: function(serie) {
        this.model.catalogo_series = this.model.catalogo_series.filter(x => x.serie != serie);
    },
    guardar: function() {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var actualizado = {
        usuario: this.usuario,
        fecha: moment().format('YYYY-MM-DD HH:mm:ss')
      }
      this.model.actualizado.push(actualizado);

      var self = this;
      this.$axios.post(this.URL + "update_empresa/", this.model)
        .then(res => {
          self.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "El registro se guardó correctamente.",
            footer: "",
          });
          self.modal = false;
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al guardar el registro.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.cargar();
          self.reset();
          self.$root.$dialogLoader.hide();
        });

    },

  },
  created: function() {
    this.URL = this.$hostname + "carta_porte/administracion/";
    this.URL_SAT = this.$hostname + "carta_porte/catalogos_sat/";
    this.rules = this.$rules;
    this.usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));


    this.cargarPaises();
    this.cargarRegimenes();
    this.cargar();
  },
};
</script>
